import { getFormFields, getArrayValue } from '../form/form';

$(function(){
  // toggle fields on load
  estateFieldsToggle();

  // new estate form
  var formEl = $('.new-estate__form');

  // on select, input change => update filter
  formEl.find('select, input').on('change', function(){
    estateFieldsToggle();
  });

  // update fields visibility and filter submit url
  function estateFieldsToggle(){
    // filter
    var formEl = $('.new-estate__form');
    if(!formEl.length) return;

    // fields
    var fieldEls = getFormFields(formEl);
      
    // values   
    var values = [];
    values['type']              = fieldEls['type'].find('select').val();                                    // type
    values['status']            = fieldEls['status'].find('select').val();                                  // status 
    values['location']          = fieldEls['location'].find('select').val();                                // location
    values['region']            = fieldEls['region'].find('select').val();                                  // region in city
    values['rural_region']      = fieldEls['rural_region'].find('select').val();                            // rural region
    values['building']          = fieldEls['building'].find('select').val();                                // building type
    values['placement']         = fieldEls['placement'].find('select').val();                               // placement type
    values['planning']          = fieldEls['planning'].find('select').val();                                // planning
    values['square']            = fieldEls['square'].find('input').val();                                   // square
    values['rooms_count']       = fieldEls['rooms_count'].find('input').val();                              // rooms count
    values['cabinets_count']    = fieldEls['rooms_count'].find('input').val();                              // cabinets count
    values['price']             = fieldEls['price'].find('input').val();                                    // price from
    values['price_type']        = fieldEls['price_type'].find('select').val();                              // price type (for square or for object)
    values['currency']          = fieldEls['currency'].find('select').val();                                // currency

    // toggle based on realty type
    if (values['type'] == 'commercial') {
      fieldEls['building'].show();
      fieldEls['placement'].show();
      fieldEls['location'].hide();
      fieldEls['rural_region'].hide();
      fieldEls['rooms_count'].hide();
      fieldEls['cabinets_count'].show();
      fieldEls['planning'].show();
    }
    else if (values['type'] == 'flats') {
      fieldEls['location'].show()
      fieldEls['building'].hide();
      fieldEls['placement'].hide();
      fieldEls['rural_region'].show();
      fieldEls['cabinets_count'].hide();
      fieldEls['rooms_count'].show();
      fieldEls['planning'].hide();
    }
    else if(values['type'] == 'houses') {
      fieldEls['location'].show();
      fieldEls['building'].hide();
      fieldEls['placement'].hide();
      fieldEls['rural_region'].show();
      fieldEls['cabinets_count'].hide();
      fieldEls['rooms_count'].show();
      fieldEls['planning'].hide();
    }
    else if(!values['type']) {
      fieldEls['location'].hide();
      fieldEls['building'].hide();
      fieldEls['placement'].hide();
      fieldEls['rural_region'].hide();
      fieldEls['cabinets_count'].hide();
      fieldEls['rooms_count'].hide();
      fieldEls['planning'].hide();
      fieldEls['region'].hide();
    }

    // toggle based on house location
    if (values['location'] == 'city' || values['type'] == 'commercial') {
      fieldEls['region'].show();
      fieldEls['rural_region'].hide();
    }
    else if (values['location'] == 'rural') {
      fieldEls['region'].hide();
      fieldEls['rural_region'].show();
    }
  }
});
